/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as warehouseSlice from './warehouseSlice';

export default function* watchWarehouseSaga() {
 yield takeLatest(warehouseSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(warehouseSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(warehouseSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(warehouseSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(
  warehouseSlice.deleteItemsStart.type,
  commonSagas.deleteItems,
 );
 yield takeLatest(warehouseSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  warehouseSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  warehouseSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  warehouseSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  warehouseSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  warehouseSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}
